var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPercent = function SvgPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M7.5 0C3.365 0 0 3.365 0 7.5S3.365 15 7.5 15 15 11.635 15 7.5 11.635 0 7.5 0m0 13.313a5.812 5.812 0 1 1 0-11.625 5.812 5.812 0 0 1 0 11.624Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M6.306 5.447c0 1.145-1.718 1.145-1.718 0s1.718-1.145 1.718 0m4.103 4.103c0 1.145-1.718 1.145-1.718 0s1.718-1.145 1.718 0m-1.32-4.833L4.717 9.09a.844.844 0 0 0 1.193 1.193l4.372-4.372a.844.844 0 0 0-1.193-1.193Z"
  })));
};
export default SvgPercent;